import { useState, useCallback } from 'react';

export function useSessionTokens() {
  const [totals, setTotals] = useState({ input: 0, output: 0 });
  const addTokens = useCallback((input = 0, output = 0) => {
    setTotals(prev => ({ input: prev.input + input, output: prev.output + output }));
  }, []);
  return { totals, addTokens };
}
